export function compareEquality(a: string, b: string, toDecimal: number) {
  return Number(a).toFixed(toDecimal) === Number(b).toFixed(toDecimal);
}
